export default [{ value: 'ac93ac88-fc41-4a7b-b47f-a120f1db1009', label: 'Overall Student Growth Score' },
{ value: '68bc220b-214d-4c9a-bd48-a389d1824bac', label: 'VAM' },
{ value: 'cd6d59be-2252-47e2-b918-2aea0e65ba97', label: 'Non-VAM' }]